<template>
  <section class="record-event fixed bottom-5 right-10 rounded-full bg-red-500">
    <div
      v-show="recording"
      class="flex items-center justify-center p-2 w-20 h-20"
    >
      <v-icon
        name="hi-microphone"
        class="text-white animate-pulse"
        :scale="2"
      />
    </div>
  </section>
</template>

<script lang="ts">
import { ChatBotService } from "@/components/ChatBot/chat-bot.service";
import { defineComponent } from "vue";

export default defineComponent({
  name: "recordStream",
  computed: {
    chatbot(): ChatBotService {
      return new ChatBotService();
    },
  },
  props: {
    encodeType: {
      type: String,
    },
    timer: {
      type: Number,
      default: 5000,
    },
  },
  data() {
    return {
      stream: {} as MediaStream,
      rec: {} as MediaRecorder,
      recording: false as boolean,
      data: [] as any,
      // TIMER: 5000 as number,
    };
  },
  methods: {
    async startStreaming(): Promise<void> {
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        await navigator.mediaDevices
          .getUserMedia({ audio: true })
          .then((stream) => {
            if (stream) {
              this.stream = stream;
              this.recordStart();
            }
          })
          .catch((e) => {
            console.error(e);
          });
      } else {
        console.error("Could not get stream.");
      }
    },
    stopStreaming(): void {
      this.stream.getAudioTracks()[0].stop();
    },
    recordStart(): void {
      this.rec = new MediaRecorder(this.stream);
      this.data.length = 0;
      this.rec.start();
      this.recording = true;
    },
    recordStop(): void {
      this.rec.stop();
      this.recording = false;
    },
    sendAudioBuffer(): void {
      this.recordStop();
      this.rec.ondataavailable = (e) => {
        this.data.push(e.data);
      };
      this.rec.onstop = () => {
        new Blob(this.data).arrayBuffer().then((buffer) => {
          let encoder = new TextEncoder().encode(this.encodeType);
          let key = new Uint8Array(encoder.buffer);
          let a1 = new Uint8Array(this.encodeType ? [0x1, key.length] : [0x0]);
          let a2 = new Uint8Array(buffer);
          let concat = new Uint8Array(
            this.encodeType ? [...a1, ...key, ...a2] : [...a1, ...a2]
          );

          this.chatbot.sendAudioActions(new Blob([concat.buffer]));
        });
        this.stopStreaming();
      };
    },
    sendActionWithRecord(): void {
      this.startStreaming();
      setTimeout(() => {
        this.sendAudioBuffer();
      }, this.timer);
    },
  },
});
</script>
